export const rentalRequestSources = {
  klickrentOnlineRequest: 'klickrent Online Request',
};

export const TRANSPORT_REQUESTED = 'zzgl. Transport zum Einsatzort';

export const TRANSPORT_NOT_REQUESTED = 'kein Transport, Selbstabholung';

export const TRANSPORT_FEE_PRODUCT_ID = '01t08000009uTRSAA2';

export const OPPORTUNITY_LINE_ITEM_STATUS = {
  acceptedByOwner: 'AcceptedByOwner',
  declinedByOwner: 'DeclinedByOwner',
};

export const OPPORTUNITY_STAGES = {
  created: 'Erstellt',
  requestSent: 'Anfrage versendet',
  offerReceived: 'Angebot erhalten',
  acceptedByOwner: 'Von Vermieter angenommen',
  closedWon: 'Closed Won',
  closedLost: 'Closed Lost',
  acceptedByKlickrent: 'Von klickrent angenommen',
  delivered: 'Ausgeliefert',
  damaged: 'Schaden',
};

export const HOURS = ['stunde', 'hour'];

export const AVERAGE_RATING = '4.7';

export const PAGES_TO_EXCLUDE_FROM_SITEMAP = ['/referenzen'];

export const PRICE_CATALOG_REQUEST_TYPES = {
  PURCHASE_REQUEST: 'purchase_request',
  RENTAL_REQUEST: 'rental_request',
};

export const RENTAL_PRODUCTS_PATH = '/mieten/produkt';
